import { createUseStyles, useTheme } from 'react-jss';
import {
  BlogsPostCardProps,
  BlogsPostCardHandlers,
  BlogsPostCardEvent,
} from '../../..';
import { buildClassName } from '../../../../helpers';
import { Theme } from '../../../../jss';
import { BlogPostCardState } from '../interfaces/blog-post-card-state.interface';
import { BlogsPostCardStyles } from '../styles';

export function useBlogsPostCardEffect(
  props: BlogsPostCardProps
): [BlogsPostCardHandlers, BlogPostCardState] {
  const onClick = (handle: string) => {
    const clickDetail = {
      id: props.id,
      value: handle,
    };

    const clickEvent: BlogsPostCardEvent = { detail: clickDetail };
    props.onClickHandler(clickEvent);
  };

  const { styleClasses } = props;

  const useStyles = createUseStyles(BlogsPostCardStyles);
  const theme = useTheme();
  const classes = useStyles({ ...props, theme: theme as Theme });
  const className = buildClassName({ styleClasses, classes });

  const handlers: BlogsPostCardHandlers = {
    onClick,
  };
  const state: BlogPostCardState = {
    className,
  };

  return [handlers, state];
}
